import { instance, endpoint, isMock, generator } from 'api'
import { mocker } from 'api/hrms75e/mocker'

export default {
  getLabels () {
    if (isMock) return generator(mocker.labels())
    return instance().get(endpoint + '/hrms75e/labels')
  },
  getIndex (searchParams) {
    let sendParams = {}
    sendParams = {
      p_codcomp: searchParams.codcomp2,
      p_codempid_query: searchParams.codempid
    }
    if (isMock) return generator(mocker.index())
    let param = searchParams.year
    return instance().get(endpoint + '/hrms75e/index/' + param, { params: sendParams })
  },
  getIndexAddInline (searchParams) {
    if (isMock) return generator(mocker.index())
    const params = searchParams.p_codempid_query
    return instance().get(endpoint + '/hrms75e/index/' + params)
  },
  getDetailCreate () {
    return generator(mocker.detailCreate())
    // if (isMock) return generator(mocker.detailCreate())
    // return instance().get(endpoint + '/hrms75e/detail1TableCreate')
  },
  getDetail (searchParams) {
    if (isMock) return generator(mocker.detail())
    const params = searchParams.p_dteyear + '/' + searchParams.p_codempid_query
    return instance().get(endpoint + '/hrms75e/detail1Table/' + params)
  },
  getPopupCours (popupParams) {
    if (isMock) return generator(mocker.popupCours())
    const params = popupParams.p_codcours
    return instance().get(endpoint + '/hrms75e/tcourse/' + params)
  },
  getDetailTab2Popup (codskillConcat) {
    if (isMock) return generator(mocker.popupTab2())
    const params = codskillConcat
    return instance().get(endpoint + '/hrms75e/detail1Tab2Popup1/' + params)
  },
  getDetailTab4Popup (popupParams) {
    if (isMock) return generator(mocker.popupTab4())
    const params = popupParams.codempid
    return instance().get(endpoint + '/hrms75e/detail1Tab4Popup1/' + params)
  },
  getDropdowns () {
    if (isMock) return generator(mocker.dropdowns())
    return instance().get(endpoint + '/hrms75e/dropdowns')
  },
  postDetailCoursSave ({ dataRowsHasFlg, searchDetailCours }) {
    var saveParams = {
      'param_json': JSON.stringify(dataRowsHasFlg)
    }
    let param = searchDetailCours.p_dteyear + '/' + searchDetailCours.p_codempid_query
    if (isMock) return generator(mocker.save())
    return instance().post(endpoint + '/hrms75e/postCours/' + param, saveParams)
  },
  postIndexCancel ({ dataRowsHasFlg, searchIndex }) {
    let param = {
      dteyear: searchIndex.year
    }
    for (var i = 0; i < dataRowsHasFlg.length; i++) {
      dataRowsHasFlg[i] = Object.assign(dataRowsHasFlg[i], param)
    }
    let sendParams = {
      param_json: JSON.stringify(dataRowsHasFlg)
    }
    if (isMock) return generator(mocker.indexCancel())
    return instance().post(endpoint + '/hrms75e/postDeleteIndex', sendParams)
  }
}



// WEBPACK FOOTER //
// ./src/api/hrms75e/index.js